<template>
<div class="el-main"
  ref="mainViewer">
  <div class="card" v-show="currentCardId == 'basic'">
    <div class="overflow-scroll-y">
      <div class="card-header">
        <h2>宛先情報入力</h2>
        <p>会社名や担当者のメールアドレスを正確に入力しましょう。</p>
      </div>
      <div class="card-content">
        <div class="edit-form">
          <div class="edit-form-item">
            <div class="item-name">
              <small style="color:red;">※</small>担当者メールアドレス
              <small >(※入力間違いがないようにご確認ください)</small>
            </div>
            <div class="item-body">
              <el-input class="input-md"
                placeholder=""
                title="メールアドレス"
                ref="email"
                v-model="formatData.addressData_commpanyStaffEmail"
                type="email"></el-input>
              <p v-if="isInValidEmail" style="color:red;">メールアドレスの形式で入力してください。</p>
            </div>
          </div>
          <div class="edit-form-item">
            <div class="item-name"><small style="color:red;">※</small>送付先の会社名</div>
            <div class="item-body">
              <el-input 
                autosize
                placeholder="会社名"
                title="会社名"
                ref="companyName"
                v-model="formatData.addressData_companyName"></el-input>
            </div>
          </div>
          <div class="edit-form-item">
            <div class="item-name">送付先の担当者名 ※様の入力は不要です。</div>
            <div class="item-body">
              <el-input 
                autosize
                placeholder="ご担当者"
                title="担当者名"
                ref="staffName"
                v-model.lazy="formatData.addressData_staffName"
                style="min-height: 36px;height: 36px;width: 80%;"
                v-model="formatData.addressData_staffName"></el-input>
                <span style="display: inline;padding: 5px;font-size: 120%;">様</span>
            </div>
          </div>
        </div>

        <div class="edit-form">
          <div class="edit-form-item">
            <p class="card-header2" style="border-bottom: none; border-top: 1px solid #f8f8f8; 
            padding: 30px 5px 0 0; margin: 0; color: #004d40; font-weight: bold;">差出人情報</p>
            <p class="card-header2" style="border: none; padding: 0; font-size: .75rem;">履歴書と異なる場合は入力しましょう。</p>
            <div class="item-name">
              <small style="color:red;">※</small>差出人のメールアドレス
            </div>
            <div class="item-body">
              <el-input class="input-md"
                placeholder=""
                title="メールアドレス"
                ref="from_email"
                v-model="formatData.from_email"
                type="email"></el-input>
              <div v-if="$firebase.isAuthenticated && $firebase.user.email !== formatData.email">
                <el-button @click="setAccountEmail"
                  type="text">「{{ $firebase.user.email }}」を入力する</el-button>
              </div>
              <p v-if="isInValidFromEmail" style="color:red;">メールアドレスの形式で入力してください。</p>
            </div>
          </div>
          <div class="edit-form-item">
            <div class="item-name"><small style="color:red;">※</small>差出人名</div>
            <div class="item-body">
              <el-input 
                autosize
                placeholder=""
                title="差出人名"
                ref="from_userName"
                v-model="formatData.from_name"></el-input>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="card" v-show="currentCardId == 'mail'">
    <div class="overflow-scroll-y">
      <div class="card-header">
        <h2>送付メール確認</h2>
        <p>送付メールの内容に間違いがないかご確認ください。</p>
        
        <p class="card-header2" style="border-bottom: none; border-top: 1px solid #f8f8f8; 
        padding: 30px 5px 0 0; margin: 0; color: #004d40; font-weight: bold;">宛先</p>
        <div class="edit-form-item" >
          <div class="item-body">
            <p>{{formatData.addressData_commpanyStaffEmail}}</p>
          </div>
        </div>
        
        <p class="card-header2" style="border-bottom: none; border-top: 1px solid #f8f8f8; 
        padding: 30px 5px 0 0; margin: 0; color: #004d40; font-weight: bold;">メールタイトル</p>
        <div class="edit-form-item" >
          <div class="item-body">
            <p>履歴書をお送りします</p>
          </div>
        </div>

        <p class="card-header2" style="border-bottom: none; border-top: 1px solid #f8f8f8; 
        padding: 30px 5px 0 0; margin: 0; color: #004d40; font-weight: bold;">メール内容</p>
        <div class="edit-form-item" >
          <div class="item-body">
            <p>{{formatData.addressData_companyName}}</p>
            <p>{{formatData.addressData_staffName}}様</p>
          </div>
          <div class="item-body">
            <p>お世話になります。</p>
            <p>{{formatData.from_name}}です。</p>
          </div>
          <div class="item-body">
            <p>貴社の求人情報を拝見し、応募させていただきたく、ご連絡差し上げました。</p>
          </div>
          <div class="item-body">
            <p>こちらのメールに以下の書類を添付しております。ご査収の程、よろしくお願いいたします。</p>
            <p>・{{formatData.from_name}}_履歴書.pdf</p>
            <p v-if="formatData.addressData_isKeirekisho">・{{formatData.from_name}}_職務経歴書.pdf</p>
          </div>
          <div class="item-body">
            <p>お忙しいところ恐れ入りますが、何卒よろしくお願いいたします。</p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="card" v-show="currentCardId == 'rirekisho'">
    <div class="overflow-scroll-y">
      <div class="card-header">
        <h2>履歴書確認</h2>
        <p>履歴書の内容に間違いがないかご確認ください。</p>
        <span style="color:red;">※プレビューに赤い色が見えた場合はプリントに問題があるので、赤い色がなくなるよう内容を編集してください。</span>
        <p style="text-align:right;"><a :href="rirekishoUrl" class="fix"><i class="el-icon-edit"></i>履歴書内容を編集する</a></p>
      </div>
      <div class="edit-form-item" style="text-align:center;">
        <h3>履歴書フォーマット選択 </h3>
        <div class="item-body">
          <el-select v-model="formatData.selFormat"
                autosize
            placeholder="選択してください">
            <el-option v-for="item in formatListOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"></el-option>
          </el-select>&nbsp;
          <el-button id="send-adtop-pdf" type="success" 
          style="background-color:#0F9934;border-color:#0F9934;;padding: 10px;"
          @click="selectFormat();">選択する</el-button>
        </div>
      </div>
    </div>
  </div>
  <div class="card" v-show="currentCardId == 'keirekisho'">
    <div class="overflow-scroll-y">
      <div class="card-header">
        <h2>職務経歴書確認</h2>
        <p>職務経歴書の内容に間違いがないかご確認ください。</p>
        <p style="text-align:right;"><a href="/format/shokumukeirekisho/edit/profile" class="fix"><i class="el-icon-edit"></i>職務経歴書内容を編集する</a></p>
        <div class="edit-form-item">
          <div class="item-body">
            <el-checkbox v-model="formatData.addressData_isKeirekisho">職務経歴書を添付する</el-checkbox>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="card" v-show="currentCardId == 'payment'">
    <div class="overflow-scroll-y">
      <div class="card-header">
        <h2>支払い</h2>
        <p>ヤギのメール便は、クレジットカード決済のみとなります。<br>
        ご利用いただけますカードは、Visa・MasterCard・American Express・JCB・Diners Club・Discoverです。<br>
        ヤギのメール便は投函までに1-2日ほどいただきますので、ご了承ください。なお送付先に届くまでの期間については配送地域や交通状況により異なります。</p>
        <p class="terms_link"><a href="/quickmailterms" target="_blank">利用規約はこちら</a></p>
      </div>
    </div>
    <div class="item-name">
      <h3>購入金額</h3>
    </div>
    <div class="item-body">
      <span style="font-size: 120%;color:red;">300円（税込）</span>
    </div>
    <div class="item-name">
      <h3>カード情報</h3>
    </div>
    <div class="item-body">
      <stripe-element-card
        ref="stripeCardElememt"
        :pk="publishableKey"
        :hidePostalCode="true"
        @token="tokenCreated" />
    </div>
    <span style="font-size: 90%;color:red;">※お客様のカード情報は保存されません。</span>
    <div class="card-content">
      <div class="edit-form">
        <div class="edit-form-item">
          <div class="item-name">
            <h3 class="h3" style="margin: 30px 0 10px;">宛先情報<a href="#" @click="$eventHub.$emit('email_goto_basic')" class="fix"><i class="el-icon-edit"></i>修正する</a></h3>
          </div>
          <div class="item-body" style="margin-left:10px;">
            {{formatData.addressData_commpanyStaffEmail}}<br>
            {{formatData.addressData_companyName}}<br>
            {{addressDataStaffName}} 様
            <span v-if="isValidStaffname" style="color:red;">※不要な「様」「さま」の入力がないか確認してください。</span>
            <span v-if="isNoneStaffname" style="color:red;">※担当者名を入力してなかったので「ご担当者」と自動入力されました。</span>
          </div>
          <div class="item-name">
            <h3 class="h3" style="margin: 30px 0 10px;">差出人情報<a href="#" @click="$eventHub.$emit('email_goto_basic')" class="fix"><i class="el-icon-edit"></i>修正する</a></h3>
          </div>
          <div class="item-body" style="margin-left:10px;">
            {{formatData.from_email}}<br>
            {{formatData.from_name}}
          </div>
          <div class="item-name">
            <h3 class="h3" style="margin: 30px 0 10px;">送付内容</h3>
            <p>※送付内容を変更する場合はそれぞれのページでご確認ください。</p>
          </div>
          <div class="item-body" style="margin-left:10px;">
            <p><i class="el-icon-document"></i> 履歴書（{{formatData.rirekishoFormatName}}）</p>
            <p v-if="formatData.addressData_isKeirekisho"><i class="el-icon-document"></i> 職務経歴書</p>
          </div>
        </div>
      </div>
      <p class="terms_link"><a href="/quickmailterms" target="_blank">利用規約はこちら</a></p>
    </div>
  </div>
  <div class="card" v-show="currentCardId == 'complete'">
    <div class="overflow-scroll-y">
      <div class="card-header">
        <h2>購入完了</h2>
        <div class="edit-form-item" style="text-align:center;padding: 10px 0 30px; font-weight: bold;">
          購入詳細はメールにてお送りいたしましたので、ご確認お願いいたします。
        </div>
        <p>ヤギのメール便をご購入いただき、ありがとうございました。
        <br>ヤギのメール便は投函までに1-2日ほどいただきますので、ご了承ください。なお送付先に届くまでの期間については配送地域や交通状況により異なります。</p>
      </div>


      <h3 class="next_bnr">次は何する？</h3>
      <div class="bnr_container">
          <div class="bnr_itemWrapper">
            <div class="bnr_item">
              <img src="/static/renew_img/mailbuy.png" alt="ヤギのメール便">
              <div class="bnr_txt">
                <a href="#" @click="$eventHub.$emit('email_goto_basic')">
                  <p>違う会社にも送るの任せろメェ〜</p>
                  <h3>ヤギのメール便<span>をつかう</span></h3>
                </a>            
              </div>
            </div>
          </div>
          <div class="bnr_itemWrapper">
            <div class="bnr_item">
              <img src="/static/renew_img/print.png" alt="コンビニプリント">
              <div class="bnr_txt">
                <a  :href="rirekishoOutputUrl">
                  <p>面接に履歴書が必要？印刷だメェ〜</p>
                  <h3>コンビニプリント<span>をつかう</span></h3>
                </a>
              </div>
            </div>
          </div>
      </div>
    </div>
  </div>

  <div class="preview-viewer tab-content"
      :style="previewLetterViewerCss"
      v-show="currentCardId == 'letter'">
    <component v-bind:is="letter_preview"
      ref="previewLetterFormat"
      :id-prefix="''"
      :format-data="formatLetterData"
      :format-id="formatId"
      :basic-data="basicData"
      :preview-scale="previewScale"
      :current-card-id="currentCardId"></component>
  </div>
  <div class="preview-viewer tab-content"
      :style="previewRirekishoViewerCss"
      v-show="currentCardId == 'rirekisho'">
    <component v-bind:is="rirekisho_preview"
      ref="previewRirekishoFormat"
      :id-prefix="''"
      :format-data="formatRirekishoData"
      :format-id="formatId"
      :basic-data="basicData"
      :preview-scale="previewScale"
      :current-card-id="currentCardId"></component>
  </div>
  <div class="preview-viewer tab-content"
      :style="previewKeirekishoViewerCss"
      v-show="currentCardId == 'keirekisho'">
    <component v-bind:is="keirekisho_preview"
      ref="previewKeirekishoFormat"
      :id-prefix="''"
      :format-data="formatKeirekishoData"
      :format-id="formatId"
      :basic-data="basicData"
      :preview-scale="previewScale"
      :current-card-id="currentCardId"></component>
  </div>
</div>
</template>
<style lang="scss" scoped>
.terms_link{
  text-align: right;
  margin: 10px 0;
}

.terms_link_deco{
  color: #E3165C;
  text-decoration:underline;
}
.addition {
  font-size: .75rem;
  margin: .5rem 0;
}
.card-header h1{
  padding-bottom: 1.5rem;
}
.card-header h2{
  padding-bottom: 1.5rem;
}
.card-header2{
  border-bottom: 1px solid #f8f8f8;
  padding-bottom: 15px;
  margin-bottom: 20px;
}
.h3{
  padding-left: 10px;
  border-left: 4px solid #0F9934;
}
.fix{
  margin-left: 20px;
}
.fix1:before{
  content: "\e5df";
  color: #004d40;
}
* {
	list-style: none;
	box-sizing: border-box;
	margin: 0;
	padding: 0;
}

img {
	width: 100%;
	vertical-align: bottom;
}

.next_bnr{
  font-size: 1rem;
  color: #004d40;
  text-align: center;
  padding: 1.2rem;
}

.bnr_container {
	display: flex;
	flex-wrap: wrap;
	margin: calc(-30px / 2);
	padding: 0 30px 30px;
}

.bnr_itemWrapper {
	width: calc(100% / 2 - 30px);
	margin: calc(30px / 2);
}

.bnr_item {
  text-align: center;
}

.bnr_item img{
  border-radius: 10px 10px 0 0 ;
}

.bnr_txt{
  padding: 15px;
  background: #EFF8F8;
  border-radius: 0 0 10px 10px;
}

.bnr_txt p{
  font-size: 0.8rem;
}

.bnr_txt h3{
  color: #E3165C;
  font-size: 1.1rem;
  font-weight: bold;
}

.bnr_txt span{
  font-size: 0.8rem;
}

/* タブレット　2カラム */
@media screen and (max-width: 1024px) {
	.bnr_itemWrapper {
		width: calc(100% / 2 - 30px);
	}
}
/* スマホ 1カラム*/
@media screen and (max-width: 599px) {
	.bnr_itemWrapper {
		width: calc(100% / 1 - 30px);
	}
}
</style>
<script>
import HistoryItem from './RirekishoParts/HistoryItem'
import AutoEducationalBackgrounds from './RirekishoParts/AutoEducationalBackgrounds'
import AutoJobHistories from './RirekishoParts/AutoJobHistories'
import LocalDataMixin from '@/mixins/local-data-mixin'
import LoginForms from '@/components/LoginForms'
import RirekishoPreview from '@/components/formats/RirekishoPreview'
import NewRirekishoPreview from '@/components/formats/NewRirekishoPreview'
import ShokurekishoPreview from '@/components/formats/ShokurekishoPreview'
import LetterPreview from '@/components/formats/LetterPreview'
import LabelPreview from '@/components/formats/LabelPreview'

import { StripeElementCard } from '@vue-stripe/vue-stripe'

// 書式1枚の高さ
const DOC_PAPER_WIDTH_PX = 794

const uuidv4 = function () {
  const cryptoObj = window.crypto || window.msCrypto
  return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
    (c ^ cryptoObj.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
  )
}
const HistoryData = function (year, month, description) {
  this.year = Number(year) || ''
  this.month = Number(month) || ''
  this.description = description || ''
  this.uuid = uuidv4()
}
export default {
  name: 'QuickmailBuy',
  props: {
    previewFormat: {
      type: Object,
      require: true
    },
    currentCardId: {
      type: String
    },
    exampleSentences: {
      type: Object
    }
  },
  mixins: [LocalDataMixin],
  components: {
    'history-item': HistoryItem,
    'auto-educational-backgrounds': AutoEducationalBackgrounds,
    'auto-job-histories': AutoJobHistories,
    'login-forms': LoginForms,
    StripeElementCard
  },
  data: function () {
    return {
      publishableKey : process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY,
		  basicData: {},
      addressData: {},
      saveName: 'rirekisho',
      formatId: 'rirekisho_job_change',
      rirekisho_preview: RirekishoPreview,
      keirekisho_preview: ShokurekishoPreview,
      letter_preview: LetterPreview,
      label_preview: LabelPreview,
      formatRirekishoData: {},
      formatKeirekishoData: {},
      formatLetterData: {},
      addressDataStaffName: "",
      rirekishoUrl:'/format/rirekisho_job_change/edit/profile',
      rirekishoOutputUrl:'/format/rirekisho_job_change/edit/output',
      activeHistoryItem: '',
      rirekishoFormatName:'転職用の履歴書（JIS規格）',
      educationalResetDialogVisible: false,
      jobResetDialogVisible: false,
      descriptionMaxLength: 80,
      mailPdfEnabled: true,
      downloadPdfEnabled: true,
      isSendYagiPostEnabled: true,
      letterInnerHtml: '',
      rirekishoInnerHtml: '',
      keirekishoInnerHtml: '',
      previewHtml: '',
      previewDialogVisible: true,
      previewScale: 1,
      previewRirekishoViewerCss: {},
      previewKeirekishoViewerCss: {},
      previewLetterViewerCss: {},
      previewLabelViewerCss: {},
      previewTabActive: 'previewFormat',
      isNew: false,
      textareaMinRows: 3,
      isValidStaffname: false,
      isNoneStaffname: false,
      downloadActiveCollapses: ['postcard'],
      formatListOptions: [],
      gradeYearOptions: [
        {
          value: '23',
          label: '23年卒'
        },
        {
          value: '24',
          label: '24年卒'
        },
        {
          value: '99',
          label: 'その他'
        }
      ],
      fontOptions: [
        {
          value: "font-family: 'Noto Sans JP', sans-serif;",
          label: 'Noto Sans JP'
        },
        {
          value: "font-family: 'Noto Serif JP', serif;",
          label: 'Noto Serif JP'
        },
        {
          value: "font-family: 'BIZ UDPMincho', serif;",
          label: 'BIZ UDP明朝'
        },
        {
          value: "font-family: 'DotGothic16', sans-serif;",
          label: 'ドットゴシック16'
        },
        {
          value: "font-family: 'Zen Maru Gothic', sans-serif;",
          label: 'Zen Maru ゴシック'
        },
        {
          value: "font-family: 'Kaisei Decol', serif;",
          label: 'Kaisei Decol'
        },
        {
          value: "font-family: 'Kiwi Maru', serif;",
          label: 'Kiwi Maru'
        },
        {
          value: "font-family: 'Klee One', cursive;",
          label: 'Klee One'
        },
        {
          value: "font-family: 'Kosugi', sans-serif;",
          label: 'Kosugi'
        },
        {
          value: "font-family: 'Mochiy Pop One', sans-serif;",
          label: 'Mochiy Pop One'
        },
        {
          value: "font-family: 'Reggae One', cursive;",
          label: 'Reggae One'
        },
        {
          value: "font-family: 'Shippori Mincho', serif;",
          label: 'Shippori 明朝'
        },
        {
          value: "font-family: 'Stick', sans-serif;",
          label: 'Stick'
        },
        {
          value: "font-family: 'Yuji Boku', serif;",
          label: 'Yuji Boku'
        },
        {
          value: "font-family: 'Yuji Mai', serif;",
          label: 'Yuji Mai'
        },
        {
          value: "font-family: 'Yusei Magic', sans-serif;",
          label: 'Yusei Magic'
        },
        {
          value: "font-family: 'Zen Kurenaido', sans-serif;",
          label: 'Zen Kurenaido'
        }
      ],
      fontNames: [
        {
          value: "font-family: 'Noto Sans JP', sans-serif;",
          label: 'Noto Sans JP'
        },
        {
          value: "font-family: 'Noto Serif JP', serif;",
          label: 'Noto Serif JP'
        },
        {
          value: "font-family: 'BIZ UDPMincho', serif;",
          label: 'BIZ UDP明朝'
        },
        {
          value: "font-family: 'DotGothic16', sans-serif;",
          label: 'ドットゴシック16'
        },
        {
          value: "font-family: 'Zen Maru Gothic', sans-serif;",
          label: 'Zen Maru ゴシック'
        },
        {
          value: "font-family: 'Kaisei Decol', serif;",
          label: 'Kaisei Decol'
        },
        {
          value: "font-family: 'Kiwi Maru', serif;",
          label: 'Kiwi Maru'
        },
        {
          value: "font-family: 'Klee One', cursive;",
          label: 'Klee One'
        },
        {
          value: "font-family: 'Kosugi', sans-serif;",
          label: 'Kosugi'
        },
        {
          value: "font-family: 'Mochiy Pop One', sans-serif;",
          label: 'Mochiy Pop One'
        },
        {
          value: "font-family: 'Reggae One', cursive;",
          label: 'Reggae One'
        },
        {
          value: "font-family: 'Shippori Mincho', serif;",
          label: 'Shippori 明朝'
        },
        {
          value: "font-family: 'Stick', sans-serif;",
          label: 'Stick'
        },
        {
          value: "font-family: 'Yuji Boku', serif;",
          label: 'Yuji Boku'
        },
        {
          value: "font-family: 'Yuji Mai', serif;",
          label: 'Yuji Mai'
        },
        {
          value: "font-family: 'Yusei Magic', sans-serif;",
          label: 'Yusei Magic'
        },
        {
          value: "font-family: 'Zen Kurenaido', sans-serif;",
          label: 'Zen Kurenaido'
        }
      ],
    }
  },
  computed: {
    isInValidEmail(){
      const reg = new RegExp(/^[A-Za-z0-9]{1}[A-Za-z0-9_.-]*@{1}[A-Za-z0-9_.-]{1,}\.[A-Za-z0-9]{1,}$/)
      console.error(this.formatData.addressData_commpanyStaffEmail)
      return !reg.test(this.formatData.addressData_commpanyStaffEmail)
    },
    isInValidFromEmail(){
      const reg = new RegExp(/^[A-Za-z0-9]{1}[A-Za-z0-9_.-]*@{1}[A-Za-z0-9_.-]{1,}\.[A-Za-z0-9]{1,}$/)
      console.error(this.formatData.from_email)
      return !reg.test(this.formatData.from_email)
    }
  },
  methods: {
    setAccountEmail: function () {
      console.error(this.$firebase.user.email)
      if (this.$firebase.user.email) {
        console.error(this.formatData.from_email)
        this.formatData.from_email = this.$firebase.user.email
        console.error(this.formatData.from_email)
      }
    },
    tokenCreated (token) {
      const app = this
      app.$eventHub.$emit('email_loading_on')
      this.token = token.id
      const formData = new FormData()
      formData.append('stripe_token', this.token)
      formData.append('quickmail_staffemail', this.formatData.addressData_commpanyStaffEmail)
      formData.append('quickmail_companyname', this.formatData.addressData_companyName)
      formData.append('quickmail_staffname', this.addressDataStaffName)
      formData.append('rirekisho_html', this.rirekishoInnerHtml)
      formData.append('keirekisho_html', this.keirekishoInnerHtml)
      formData.append('letter_html', this.letterInnerHtml)
      formData.append('letter_flag', this.formatData.addressData_isLetter)
      formData.append('keirekisho_flag', this.formatData.addressData_isKeirekisho ? '1':'0')
      formData.append('format_id', this.formatData.selFormat)
      formData.append('font_name', this.formatData.selFontStyle4DB)
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('from_post', this.formatData.from_post)
      formData.append('from_email', this.formatData.from_email)
      formData.append('from_name', this.formatData.from_name)
      formData.append('app_flag', '')
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP': 'PC')
      formData.append('version', '2')
      formData.append('site_flag', 'd')
      this.$axios
        .post(this.$varuna.endPoints.paymentQuickemail, formData, {timeout: 60000})
        .then(function (response) {
          if (response.data['status'] == 'success') {
            app.$message({
              message: '購入完了しました',
              type: 'success'
            })
            app.$eventHub.$emit('payment_email_result', 'success')
          } else {
            app.$message({
              message: '決済失敗しました',
              type: 'error'
            })
            app.$eventHub.$emit('payment_email_result', 'error')
          }
        })
        .catch(function (error) {
          app.$message({
            message: '決済失敗しました',
            type: 'error'
          })
          app.$eventHub.$emit('payment_email_result', 'error')
        }).finally(function () {
        })
    },
    selectedPostnumber() {
      if (String(this.formatData.addressData_postNumber).length === 7) {
        this.setAddressFromZip(this.formatData.addressData_postNumber)
      }
    },
    getInputValue: function (inputvalue) {
      return inputvalue?inputvalue:''
    },
    setAddressFromZip: function (postNumber) {
      const app = this
      const callback = function (data) {
        app.$refs.address1.value = data.kanji
        app.formatData.addressData_address1 = data.kanji
      }
      this.$formLib.addressFromZip(postNumber, callback)
    },
    testFunction: function (str) {
      console.error("testFunction:" + str)
      this.$eventHub.$emit('payment_email_result', '8989')
    },
    previewScrollTo: function (id) {
      if (!id) {
        return
      }
      this.$nextTick(function () {
        const element = document.getElementById(id)
        if (element) {
          element.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
            inline: 'center'
          })
        }
      })
    },
    setPreviewScale: function () {
      let viewerRef = this.$refs.mainViewer
      this.$nextTick(function () {
        const clientWidth = this.$refs.mainViewer.clientWidth
        this.previewScale = clientWidth / Math.max(clientWidth, DOC_PAPER_WIDTH_PX)
        this.$nextTick(function () {
          this.setPreviewHeight()
        })
      })
    },
    setPreviewHeight: function () {
      const rirekishoheight = this.$refs.previewRirekishoFormat.$refs.previewMain.getBoundingClientRect().height
      const keirekishoheight = this.$refs.previewKeirekishoFormat.$refs.previewMain.getBoundingClientRect().height
      const letterheight = this.$refs.previewLetterFormat.$refs.previewMain.getBoundingClientRect().height
      // const labelheight = this.$refs.previewLabelFormat.$refs.previewMain.getBoundingClientRect().height
      this.previewRirekishoViewerCss = {
        height: rirekishoheight + 30 + 'px'
      }
      this.previewKeirekishoViewerCss = {
        height: keirekishoheight + 30 + 'px'
      }
      this.previewLetterViewerCss = {
        height: letterheight + 'px'
      }
      // this.previewLabelViewerCss = {
      //   height: labelheight + 'px'
      // }
    },
    setLetterInnerHtml: function () {
      this.letterInnerHtml = this.$refs.previewLetterFormat.$el.innerHTML
    },
    setRirekishoInnerHtml: function () {
      this.rirekishoInnerHtml = this.$refs.previewRirekishoFormat.$el.innerHTML
    },
    setKeirekishoInnerHtml: function () {
      this.keirekishoInnerHtml = this.$refs.previewKeirekishoFormat.$el.innerHTML
    },
    setCheckLetter: function () {
      if (this.formatLetterData.createDate) {
        this.formatData.addressData_isLetter = '1'
      } else {
        this.formatData.addressData_isLetter = '0'
      }
    },
    setAddressDataStaffName: function () {
      if (!this.formatData.addressData_staffName) {
        this.isNoneStaffname = true
        this.addressDataStaffName = 'ご担当者'
      } else {
        this.addressDataStaffName = this.formatData.addressData_staffName
      }
    },
    showPreview: function () {
      this.previewDialogVisible = true
      this.previewTabActive = 'previewFormat'
      this.setPreviewScale()
      this.$nextTick(function () {
        this.previewScrollTo(this.currentCardPreviewJumpId)
      })
    },
    selectFormat: function (isMessaege) {
      // console.error(this.$refs.previewRirekishoFormat.$el)
      // console.error(this.$refs.previewRirekishoFormat.$el.innerHTML)
      for (let key in this.$site.formatsIndex) {
        let item = this.$site.formatsIndex[key]
        if (item.id == this.formatData.selFormat) {
          this.rirekisho_preview = item.components.preview
          this.formatId = item.id
          this.formatData.rirekishoFormatName = item.title
          if (!isMessaege) {
            this.$message({
              message: this.formatData.rirekishoFormatName+'に履歴書フォーマットを変更しました。プレビューをご確認ください',
              type: 'success'
            })
          }
          this.rirekishoUrl = '/format/'+this.formatId+'/edit/profile'
          this.rirekishoOutputUrl = '/format/'+this.formatId+'/edit/output'
        }
      }
      this.$nextTick(function () {
        this.$refs.previewRirekishoFormat.checkValid()
        this.setRirekishoInnerHtml()
      })
    },
    selectFont: function() {
      const app = this
      this.formatData.selFontStyle = this.formatData.selFont
      this.formatData.selFontStyle4DB = this.formatData.selFont
      
      for (const label_name in this.fontOptions) {
        if (this.fontNames[label_name].value == this.formatData.selFont) {
          this.formatData.selectedFontName = '選択したフォント（' + this.fontNames[label_name].label + '）'
          this.formatData.selFontStyle4DB = this.fontNames[label_name].label
        }
      }
    },
    cleanUp: function (name, value) {
      if (name === 'postNumber') {
        value = value.replace('-', '')
        value = this.$formLib.zenToHanNumber(value)
        return String(value)
      }
    },
  },
  watch: {
    'formatData.addressData_postNumberX': function (newValue, oldValue) {
      console.error('formatData.addressData_postNumber')
      // skip first load
      if (!oldValue) {
        return
      }
      const postNumber = this.cleanUp('postNumber', String(newValue))
      if (String(postNumber).length === 7) {
        this.setAddressFromZip(postNumber)
      }
    },
    'formatData.addressData_staffName': function (newValue, oldValue) {
      if (newValue.indexOf('さま') >= 0 || newValue.indexOf('様') >= 0) {
          this.isValidStaffname = true
      } else {
          this.isValidStaffname = false
      }
    }
  },
  mounted: function () {
  },
  beforeMount: function () {
    const app = this
    this.$iterateStorage(function (value, key, iterationNumber) {
      if (key === 'basicData') {
        app.basicData = value
        app.formatData.from_name = app.basicData.lastName + ' ' +  app.basicData.firstName
        app.formatData.from_post = app.basicData.postNumber
        app.formatData.from_address1 = app.basicData.address1
        app.formatData.from_address2 = app.basicData.address2
        app.formatData.from_email = app.basicData.email
        console.error(app.formatData.from_email)
      }
      if (key === 'format_rirekisho') {
        app.formatRirekishoData = value
        if (value.selFormat) {
          app.selectFormat(true)
        }
      }
      if (key === 'format_shokumukeirekisho') {
        app.formatKeirekishoData = value
      }
      if (key === 'format_letter') {
        app.formatLetterData = value
        app.formatData.addressData_companyName = value.company_name
        app.formatData.addressData_staffName = value.staff_name
      }
      if (key === 'recentEdit') {
        if (value.FormatId == 'letter' || value.FormatId == 'shokumukeirekisho') {
          app.selectFormat(true)
        } else {
          app.formatData.selFormat = value.FormatId
          app.selectFormat(true)
        }
      }
    }, function (err) {})
    let idx = 0
    for (let key in this.$site.formatsIndex) {
      let item = this.$site.formatsIndex[key]
      if (item.id != 'letter' && item.id != 'shokumukeirekisho') {
        this.formatListOptions[idx] = {
          value: item.id,
          label: item.title
        }
        idx++
      }
    }
    this.showPreview()
  },
  destroyed: function () {
  }
}
</script>
